export const TRAINING_CATEGORIES_STORAGE_KEY = "besarawak_training_categories_v1";

export const DEFAULT_TRAINING_CATEGORIES = [
  { id: "TC-001", name: "Leadership & Management", description: "Training related to leadership, management and soft skills.", status: "Active" },
  { id: "TC-002", name: "Technical Skills", description: "Technical and job-specific skill development.", status: "Active" },
  { id: "TC-003", name: "Compliance & Regulatory", description: "Training related to compliance, legal and regulatory requirements.", status: "Active" },
  { id: "TC-004", name: "Health & Safety", description: "Workplace safety and health related training.", status: "Active" },
  { id: "TC-005", name: "IT Systems", description: "Training on IT systems and digital tools.", status: "Active" },
  { id: "TC-006", name: "Customer Service", description: "Customer service and communication skills.", status: "Active" },
  { id: "TC-007", name: "Others", description: "Other training categories.", status: "Inactive" },
];

const copy = (value) => JSON.parse(JSON.stringify(value));

export const loadTrainingCategories = () => {
  try {
    const stored = JSON.parse(localStorage.getItem(TRAINING_CATEGORIES_STORAGE_KEY));
    return Array.isArray(stored) ? stored : copy(DEFAULT_TRAINING_CATEGORIES);
  } catch (error) {
    return copy(DEFAULT_TRAINING_CATEGORIES);
  }
};

export const saveTrainingCategories = (categories) => localStorage.setItem(TRAINING_CATEGORIES_STORAGE_KEY, JSON.stringify(categories));
export const getActiveTrainingCategories = () => loadTrainingCategories().filter((category) => category.status === "Active");
